
export default class InitialLaunchService {
    public static readonly IS_INIITAL_LAUNCH = 'INITIAL_LAUNCH';

    public static SetInitLaunch(isInitialLaunch : boolean) {
        localStorage.setItem(this.IS_INIITAL_LAUNCH, JSON.stringify(isInitialLaunch));
    }

    public static GetInitLaunch(): boolean {

        const isInitLuanch = localStorage.getItem(this.IS_INIITAL_LAUNCH);
        if (isInitLuanch) {
            return JSON.parse(isInitLuanch) as boolean;
        }

        return true;
    }
}